<template>
    <div class="setup-container">
        <div class="header-search">
            <!-- <div class="search-bar">
                <Search />
                <input type="text" placeholder="Search..." v-model="searchQuery" />
            </div> -->
        </div>
        <div>
            <p class="application-title">Executive Member's Approval</p>
        </div>
        <!-- Table -->
        <table class="table">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Application ID</th>
                    <th>Fullname</th>
                    <th>Phone</th>
                    <th>Email</th>
                    <th>Date</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in paginatedData" :key="item.id">
                    <td>{{ (currentPage - 1) * pageSize + index + 1 }}</td>
                    <td>{{ item.application_id }}</td>
                    <td>{{ item.lastname }} {{ item.firstname }} {{ item.othernames }}</td>
                    <td>{{ item.phone }}</td>
                    <td>{{ item.email }}</td>
                    <td>{{ item.created_at }}</td>
                    <td class="actions">
                        <button @click="viewItem(item)" class="btn view">
                            <ArrowUpRight class="icon" />
                        </button>
                        <button @click="rejectItem(item)" class="btn view">
                          <XCircle class="icon" />
                        </button>
                        <button @click="approveItem(item)" class="btn delete">
                            <PenLine class="icon" />
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- Pagination -->
        <div class="pagination">
            <button @click="prevPage" :disabled="currentPage === 1">
                <ChevronLeft />
            </button>
            <button v-for="page in totalPages" :key="page" @click="goToPage(page)"
                :class="{ active: currentPage === page }">
                {{ page }}
            </button>
            <button @click="nextPage" :disabled="currentPage === totalPages">
                <ChevronRight />
            </button>
        </div>
    </div>
    <div
        v-if="showModal"
        class="modal fade show"
        style="display: block; background: rgba(0, 0, 0, 0.6);"
        @click.self="closeModal"
        >
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content rounded-3 shadow-lg border-0">
            <!-- Header -->
            <div style="background-color: #ED4E24;" class="modal-header text-white rounded-top">
              <h5 class="modal-title fw-bold">
                <i class="fa fa-id-card me-2"></i> Application Details
              </h5>
              <button type="button" class="btn-close btn-close-white" @click="closeModal"></button>
            </div>

            <!-- Body -->
            <div class="modal-body p-4">
              <div v-if="selectedItem">
                <!-- Applicant Information -->
                <h6 class="fw-bold mb-3 border-bottom pb-2 text-secondary">
                  Applicant Information
                </h6>
                <div class="row g-3 mb-4">
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">First Name</label>
                    <p class="text-dark mb-0">{{ selectedItem.firstname }}</p>
                  </div>
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Last Name</label>
                    <p class="text-dark mb-0">{{ selectedItem.lastname }}</p>
                  </div>
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Other Name</label>
                    <p class="text-dark mb-0">{{ selectedItem.othernames }}</p>
                  </div>
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Email</label>
                    <p class="text-dark mb-0">{{ selectedItem.email }}</p>
                  </div>
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Phone</label>
                    <p class="text-dark mb-0">{{ selectedItem.phone }}</p>
                  </div>
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Address</label>
                    <p class="text-dark mb-0">{{ selectedItem.address }}</p>
                  </div>
                </div>

                <!-- Application Details -->
                <h6 class="fw-bold mb-3 border-bottom pb-2 text-secondary">
                  Application Details
                </h6>
                <div class="row g-3 mb-4">
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Application ID</label>
                    <p class="text-dark mb-0">{{ selectedItem.application_id }}</p>
                  </div>
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Member ID</label>
                    <p class="text-dark mb-0">{{ selectedItem.memberId }}</p>
                  </div>
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Profession</label>
                    <p class="text-dark mb-0">{{ selectedItem.profession }}</p>
                  </div>
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Employer</label>
                    <p class="text-dark mb-0">{{ selectedItem.employer }}</p>
                  </div>
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Employer Address</label>
                    <p class="text-dark mb-0">{{ selectedItem.empl_office_address }}</p>
                  </div>
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Employer Phone</label>
                    <p class="text-dark mb-0">{{ selectedItem.empl_office_phone }}</p>
                  </div>

                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Nature of Business</label>
                    <p class="text-dark mb-0">{{ selectedItem.work_status }}</p>
                  </div>
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Present Membership</label>
                    <p class="text-dark mb-0">{{ selectedItem.other_club_membership }}</p>
                  </div>
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Expelled?</label>
                    <p class="text-dark mb-0">{{ selectedItem.expelled }}</p>
                  </div>

                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Expelled Reason?</label>
                    <p class="text-dark mb-0">{{ selectedItem.reason_expelled }}</p>
                  </div>

                  <!-- Game Interest -->
                <h6 class="fw-bold mb-3 border-bottom pb-2 text-secondary">
                Game Interest
                </h6>
                <div class="row g-0 mb-0">
                <div class="col-md-12">
                    <ul class="list-inline mb-0">
                    <li
                        v-for="(game, index) in parsedGameInterest"
                        :key="index"
                        class="badge bg-info text-dark me-2 mb-0 px-3 py-2 rounded-pill"
                    >
                        {{ game }}
                    </li>
                    </ul>
                </div>
                </div>

                  

                </div>

                <!-- Children -->
                <h6 class="fw-bold mb-3 border-bottom pb-2 text-secondary">
                  Children
                </h6>
                <div class="table-responsive mb-4">
                  <table class="table table-sm table-striped align-middle">
                    <thead class="table-light">
                      <tr>
                        <th>Name</th>
                        <th>Sex</th>
                        <th>Date of Birth</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(child, index) in parsedChildren" :key="index">
                        <td>{{ child.name }}</td>
                        <td>{{ child.sex }}</td>
                        <td>{{ child.dob }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Sponsors -->
                <!-- <h6 class="fw-bold mb-3 border-bottom pb-2 text-secondary">
                  Sponsor Information
                </h6>
                <div class="row g-3 mb-4">
                  <div class="col-md-6">
                    <label class="fw-semibold text-muted">First Sponsor</label>
                    <p class="text-dark mb-0">
                      {{ selectedItem.first_sponsor_firstname }} {{ selectedItem.first_sponsor_lastname }}
                      <br />
                      <small class="text-muted">Member ID: {{ selectedItem.first_sponsorId }}</small>
                      <br />
                      <small class="text-muted">Approval Status: 
                        <span class="text-warning" v-if="selectedItem.sponsor_approval === 'pending'">{{ selectedItem.sponsor_approval }}</span>
                        <span class="text-success" v-else-if="selectedItem.sponsor_approval === 'approved'">{{ selectedItem.sponsor_approval }}</span>
                    </small>
                    </p>
                  </div>
                  <div class="col-md-6">
                    <label class="fw-semibold text-muted">Second Sponsor</label>
                    <p class="text-dark mb-0">
                      {{ selectedItem.second_sponsor_firstname }} {{ selectedItem.second_sponsor_lastname }}
                      <br />
                      <small class="text-muted">Member ID: {{ selectedItem.second_sponsorId }}</small>
                      <br />
                      <small class="text-muted">Approval Status: 
                        <span class="text-warning" v-if="selectedItem.sponsor_approval2 === 'pending'">{{ selectedItem.sponsor_approval }}</span>
                        <span class="text-success" v-else-if="selectedItem.sponsor_approval2 === 'approved'">{{ selectedItem.sponsor_approval }}</span>
                    </small>
                    </p>
                  </div>
                </div> -->

                <!-- Executives -->
                <h6 class="fw-bold mb-3 border-bottom pb-2 text-secondary">
                  Executive Information
                </h6>
                <div class="row g-3 mb-4">
                  <div class="col-md-6">
                    <label class="fw-semibold text-muted">First Executive</label>
                    <p class="text-dark mb-0">
                      {{ selectedItem.first_executive_firstname }} {{ selectedItem.first_executive_lastname }}
                      <br />
                      <small class="text-muted">Member ID: {{ selectedItem.first_executiveId }}</small>
                      <br />
                      <small class="text-muted">Approval Status: <span class="text-warning">{{ selectedItem.executive_member_approval }}</span></small>
                    </p>
                  </div>
                  <div class="col-md-6">
                    <label class="fw-semibold text-muted">Second Executive</label>
                    <p class="text-dark mb-0">
                      {{ selectedItem.second_executive_firstname }} {{ selectedItem.second_executive_lastname }}
                      <br />
                      <small class="text-muted">Member ID: {{ selectedItem.second_executiveId }}</small>
                      <br />
                      <small class="text-muted">Approval Status: <span class="text-warning">{{ selectedItem.executive_approval2 }}</span></small>
                    </p>
                  </div>
                </div>

                <!-- Documents -->
                <h6 class="fw-bold mb-3 border-bottom pb-2 text-secondary">
                  Document Information
                </h6>
                <div class="row g-3 mb-4">
                  <div class="col-md-4" v-if="selectedItem.bank_statement">
                    <label class="fw-semibold text-muted">6 months personal or company statement</label>
                    <a :href="base_url + selectedItem.bank_statement" target="_blank" class="text-primary d-block text-decoration-none">
                      View File
                    </a>
                  </div>
                  <div class="col-md-4" v-if="selectedItem.means_identification">
                    <label class="fw-semibold text-muted">Valid Means of Identification</label>
                    <a :href="base_url + selectedItem.means_identification" target="_blank" class="text-primary d-block text-decoration-none">
                      View File
                    </a>
                  </div>
                  <div class="col-md-4" v-if="selectedItem.recent_utility">
                    <label class="fw-semibold text-muted">Recent Utility Bill</label>
                    <a :href="base_url + selectedItem.recent_utility" target="_blank" class="text-primary d-block text-decoration-none">
                      View File
                    </a>
                  </div>
                </div>

                <!-- Signature -->
                <h6 class="fw-bold mb-3 border-bottom pb-2 text-secondary">
                  Signature
                </h6>
                <div class="text-center">
                  <img
                    v-if="selectedItem.signature"
                    :src="base_url + selectedItem.signature"
                    alt="Signature"
                    class="img-fluid border rounded shadow-sm"
                    style="max-width: 300px;"
                  />
                  <p class="mt-2 text-muted">
                    <strong>Name:</strong> {{ selectedItem.signature_name }}
                  </p>
                  <p class="text-muted">
                    <strong>Date Submitted:</strong> {{ selectedItem.submit_date }}
                  </p>
                </div>
              </div>
            </div>

            <!-- Footer -->
            <div class="modal-footer bg-light d-flex justify-content-end gap-2">
              <button class="btn btn-secondary" @click="closeModal">
                <i class="fa fa-times me-1"></i> Close
              </button>
            </div>
          </div>
        </div>
    </div>
</template>

<script setup>
import { ArrowUpRight, XCircle, ChevronLeft, ChevronRight, PenLine } from "lucide-vue-next";
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import axios from 'axios';

const dataList = ref([]);

const showModal = ref(false);
const selectedItem = ref(null);
let base_url = process.env.VUE_APP_BASE_LIVE_URL

// Pagination state
const currentPage = ref(1);
const pageSize = 8;
const memberId = ref(localStorage.getItem('member_id'));

onMounted( async () => {
  await listRecords();
  
});

onBeforeUnmount( async () => {
  
});

// Computed values
const totalPages = computed(() =>
    Math.ceil(dataList.value.length / pageSize)
);

const paginatedData = computed(() => {
    const start = (currentPage.value - 1) * pageSize;
    return dataList.value.slice(start, start + pageSize);
});

// Pagination methods
function goToPage(page) {
    if (page >= 1 && page <= totalPages.value) {
        currentPage.value = page;
    }
}

function prevPage() {
    if (currentPage.value > 1) {
        currentPage.value--;
    }
}

function nextPage() {
    if (currentPage.value < totalPages.value) {
        currentPage.value++;
    }
}

// Action methods
const listRecords = async () => {
  try {
    //const token = localStorage.getItem("jwt_token"); // wherever you stored it
    
    const response = await axios.get(`/list_members_approval.php?memberId=${memberId.value}`, { 
        
    });
    if (response.data.status) dataList.value = response.data.data;
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

function viewItem(data) {
    selectedItem.value = data;
    showModal.value = true;
}

function closeModal() {
  showModal.value = false;
}
const rejectItem = async (item) => {
    const reason = prompt(
        `Enter reason for rejecting ${item.firstname} ${item.lastname}:`
    );

    if (!reason || !reason.trim()) {
        alert("Rejection reason is required.");
        return;
    }

    if (confirm(`Are you sure you want to reject ${item.firstname}?`)) {
        try {
            const response = await axios.post('/executive_reject_application.php', {
                id: item.application_id,
                memberId: memberId.value,
                reason: reason.trim()
            });

            if (response.data.status) {
                alert(response.data.message);

                // Remove from local data
                dataList.value = dataList.value.filter(
                    i => i.application_id !== item.application_id
                );
            } else {
                console.error(response.data.message);
            }
        } catch (error) {
            console.error('Rejection failed:', error.message);
        }
    }
};


const approveItem = async (item) => {
    if (confirm(`Are you sure you want to approve ${item.firstname}?`)) {
        try {
            const response = await axios.get(`/executive_approve_application.php?id=${item.application_id}&memberId=${memberId.value}`);
            if (response.data.status) {
                alert(response.data.message);
                // Remove from local data
                dataList.value = dataList.value.filter(i => i.application_id !== item.application_id);
            } else {
                console.error(response.data.message);
            }
        } catch (error) {
            console.error('Approval failed:', error.message);
        }
    }
}
</script>

<style scoped>
.setup-container {
    min-height: 100vh;
    padding: 24px;
}
.application-title{
    text-align: left;
}
/* Header: Setup button + search bar */
.header-search {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    width: 100%;
    margin-bottom: 16px;
}

/* Search bar */
.search-bar {
    display: flex;
    align-items: center;
    gap: 8px;
    border: 1px solid #CED4DA;
    border-radius: 8px;
    padding: 8px 12px;
    flex: 1 1 200px;
    /* allows shrinking */
    max-width: 350px;
}

.search-bar input {
    border: none;
    outline: none;
    width: 100%;
    font-size: 16px;
}

/* Table styles */
.table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 16px;
    border-radius: 8px;
    overflow-x: auto;
}

.table thead {
    display: table-header-group;
}

.table tbody {
    display: table-row-group;
}

.table th,
.table td {
    border: 1px solid #E9ECEF;
    border-radius: 8px;
    box-shadow: #6C757D33 0px 1px 3px 0px, #6C757D1A 0px 1px 2px 0px;
    padding: 12px 16px;
    text-align: left;
    font-size: 14px;
}

.table th {
    background: #fff;
    color: #6C757D;
}

.actions {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
}

.setup-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background-color: #fff;
    color: #DB6813;
    border: 1px solid #DB6813;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
}

/* Buttons */
.btn {
    width: 36px;
    height: 36px;
    border: 1px solid #CED4DA;
    border-radius: 8px;
    color: #343A40;
    background: white;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
}

.btn:hover {
    border: 1px solid #0DCAF0;
    color: #0DCAF0;
}

.btn .icon {
    width: 18px;
    height: 18px;
}

/* Pagination */
.pagination {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 12px;
}

.pagination button {
    width: 36px;
    height: 36px;
    border: 1px solid #CED4DA;
    border-radius: 8px;
    color: #343A40;
    background: white;
    cursor: pointer;
}

.pagination button.active {
    border: 1px solid #0057FC;
    color: #0057FC;
}

.pagination button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: #E9ECEF;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
    .setup-container {
        padding: 12px;
    }

    .table th,
    .table td {
        padding: 8px 10px;
        font-size: 12px;
    }

    .search-bar {
        flex: 1 1 100%;
        margin-top: 8px;
    }

    .setup-btn {
        padding: 6px 10px;
        font-size: 12px;
    }

    .btn {
        width: 32px;
        height: 32px;
    }

    .btn .icon {
        width: 16px;
        height: 16px;
    }

    .pagination button {
        width: 32px;
        height: 32px;
        font-size: 12px;
    }

    /* Make table scrollable on mobile */
    .table {
        display: block;
        overflow-x: auto;
        white-space: nowrap;
    }
}
</style>
